<template>
    <div>测试组件</div>
</template>

<script>
    export default {
        name: "test"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test/test.vue